const contactCards = [
  {
    img: {
      src: require("@/assets/img/BTC_Resnik.webp"),
      fb: require("@/assets/img/BTC_Resnik.jpg"),
      alt: "Metka Resnik",
    },
    name: "Metka Resnik",
    position: "Vodja prodaje in poslovnega kontrolinga",
    tel: "+386 1 585 13 83",
    mail: "metka.resnik@btc.si",
  },
  {
    img: {
      src: require("@/assets/img/BTC_Pohar.webp"),
      fb: require("@/assets/img/BTC_Pohar.jpg"),
      alt: "Matevž Pohar",
    },
    name: "Matevž Pohar",
    position: "Pomočnik direktorja BTC Logističnega centra",
    tel: "+386 1 585 11 88",
    mail: "matevz.pohar@btc.si",
  },
  {
    img: {
      src: require("@/assets/img/BTC_kosir.webp"),
      fb: require("@/assets/img/BTC_kosir.jpg"),
      alt: "Robi Košir",
    },
    name: "Robi Košir",
    position: "Direktor BTC Logističnega centra",
    tel: "+386 1 585 11 88",
    mail: "robi.kosir@btc.si",
  },
];

export default contactCards;
